module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsMother.0a4b127.webp";